import React from 'react';
import { cn } from '../../utils/cn';

const buttonVariants = {
  variant: {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    success: 'btn-success',
    warning: 'btn-warning',
    error: 'btn-error',
    ghost: 'btn-ghost',
    outline: 'border border-gray-300 bg-transparent text-gray-700 hover:bg-gray-50 focus:ring-gray-500',
  },
  size: {
    sm: 'btn-sm',
    md: 'btn-md',
    lg: 'btn-lg',
    xl: 'btn-xl',
  },
};

const Button = React.forwardRef(({
  className,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  children,
  ...props
}, ref) => {
  return (
    <button
      className={cn(
        'btn',
        buttonVariants.variant[variant],
        buttonVariants.size[size],
        loading && 'cursor-not-allowed opacity-70',
        className
      )}
      disabled={disabled || loading}
      ref={ref}
      {...props}
    >
      {loading && (
        <div className="spinner-sm mr-2" />
      )}
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;